var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11972_89484",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V23H23V1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11972_89484)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11972_89484",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H23V23H1V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11972_89484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.55469 11.2642C5.55469 9.31823 7.1322 7.74072 9.07812 7.74072C11.0241 7.74072 12.6016 9.31823 12.6016 11.2642C12.6016 13.2101 11.0241 14.7876 9.07812 14.7876C7.1322 14.7876 5.55469 13.2101 5.55469 11.2642Z",
    stroke: "#6F767E",
    strokeWidth: 1.65,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0547 22.1406H3.57811C2.41241 22.1406 1.58479 21.0047 1.94173 19.895C2.88993 16.9469 5.79599 14.8136 9.05929 14.8136C10.616 14.8136 12.0593 15.299 13.2461 16.1268",
    stroke: "#6F767E",
    strokeWidth: 1.65,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4492 5.38281C14.4492 3.43689 16.0267 1.85938 17.9727 1.85938C19.9186 1.85938 21.4961 3.43689 21.4961 5.38281C21.4961 7.32874 19.9186 8.90625 17.9727 8.90625C16.0267 8.90625 14.4492 7.32874 14.4492 5.38281Z",
    stroke: "#6F767E",
    strokeWidth: 1.65,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6287 11.2266C13.9643 9.81375 15.8562 8.9322 17.9539 8.9322C19.5106 8.9322 20.9539 9.41766 22.1407 10.2455",
    stroke: "#6F767E",
    strokeWidth: 1.65,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.918 22.1406V15.6953",
    stroke: "#6F767E",
    strokeWidth: 1.65,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1406 18.918H15.6953",
    stroke: "#6F767E",
    strokeWidth: 1.65,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessManager);
export default __webpack_public_path__ + "static/media/access_manager.685a92df6dccbe8de35ae4fea6cd67e0.svg";
export { ForwardRef as ReactComponent };